import { Alert, Card, Typography } from "antd";
import { InvestmentReviewTable } from "./InvestmentReviewTable";

const InvestmentReviewPage = () => (
  <Card>
    <Typography.Title level={4}>کنترل کیفیت داده‌های سرمایه‌گذاری</Typography.Title>
    <Typography.Paragraph type="secondary">
      گروه‌های unresolved بر اساس normalized identity key نمایش داده می‌شوند. هر تصمیم روی همه occurrenceهای حل‌نشده همان کلید اعمال می‌شود.
    </Typography.Paragraph>
    <Alert
      className="mb-4"
      type="info"
      showIcon
      message="اثر تصمیم‌های کنترل کیفیت"
      description={
        <div className="space-y-1 text-sm">
          <div><strong>اتصال به هویت موجود:</strong> occurrenceهای فعلی Manual Match می‌شوند و در صورت نیاز SimilarName ثبت می‌شود تا scrapeهای بعدی همان نام را خودکار match کنند.</div>
          <div><strong>ساخت OtherCompany:</strong> یک هویت جدید برای شرکت خارج از master Company ساخته می‌شود، occurrenceهای فعلی به آن وصل می‌شوند و ارتباط CompanyInvestIn برای شرکت‌های سرمایه‌گذار ثبت می‌شود.</div>
          <div><strong>Ignore پایدار:</strong> یک rule دائمی برای همان normalized key ثبت می‌شود تا در scrapeهای بعدی دوباره وارد صف QC نشود.</div>
        </div>
      }
    />
    <InvestmentReviewTable />
  </Card>
);

export default InvestmentReviewPage;
export { useInvestmentReviewRoutes } from "./routes";
